import { render, staticRenderFns } from "./AssignUserColumn.vue?vue&type=template&id=11b4bb55&scoped=true"
import script from "./AssignUserColumn.ts?vue&type=script&lang=ts&external"
export * from "./AssignUserColumn.ts?vue&type=script&lang=ts&external"
import style0 from "./AssignUserColumn.vue?vue&type=style&index=0&id=11b4bb55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b4bb55",
  null
  
)

export default component.exports